// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";
import "firebase/database";

import {
  Component,
  OnInit,
  Inject,
  AfterViewChecked,
  ChangeDetectorRef,
} from "@angular/core";
import { ChatService, Message, PayloadMessage } from "../chat.service";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/scan";
import { DOCUMENT } from "@angular/common";
import { SpeechRecognizerService } from "./shared/services/speech-recognizer.service";
import { SpeechNotification } from "./shared/model/speech-notification";
import { SpeechError } from "./shared/model/speech-error";
import { ActionContext } from "./shared/model/strategy/action-context";

const firebaseConfig = {
  apiKey: "AIzaSyDh_vk_6xJma6hiAFCXio3bEGeegX9wqoI",
  authDomain: "translater-qpjoej.firebaseapp.com",
  databaseURL: "https://translater-qpjoej.firebaseio.com",
  projectId: "translater-qpjoej",
  storageBucket: "translater-qpjoej.appspot.com",
  messagingSenderId: "372697091105",
  appId: "1:372697091105:web:239bebf0cef29b540ee760",
};
const app = firebase.initializeApp(firebaseConfig);
@Component({
  // tslint:disable-next-line: component-selector
  selector: "chat-dialog",
  templateUrl: "./chat-dialog.component.html",
  styleUrls: ["./chat-dialog.component.css"],
})
export class ChatDialogComponent implements OnInit, AfterViewChecked {
  messages: Observable<Message[]>;
  formValue: string;
  emailShareValue: string;
  initialList: boolean;
  sharePressed: boolean;
  finalHeight: number;
  finalTranscript = "";
  recognizing = false;
  notification: string;
  languages: string[] = ["en-US"];
  currentLanguage: string;
  actionContext: ActionContext = new ActionContext();
  endConversation: boolean;
  checkedCond: boolean;
  speakEnabled: boolean;

  constructor(
    public chat: ChatService,
    @Inject(DOCUMENT) private document: Document,
    private changeDetector: ChangeDetectorRef,
    private speechRecognizer: SpeechRecognizerService
  ) {}
  ngOnInit() {
    // appends to array after each new message is added to feedSource
    this.messages = this.chat.conversation
      .asObservable()
      .scan((acc, val) => acc.concat(val));
    this.initialList = true;
    this.formValue = "Hello";
    this.finalHeight = 5000;
    this.currentLanguage = this.languages[0];
    this.speechRecognizer.initialize(this.currentLanguage);
    this.initRecognition();
    this.notification = null;
    this.endConversation = false;
    this.checkedCond = false;
    this.speakEnabled = true;
    window.scrollTo(0, this.finalHeight);
  }
  ngAfterViewChecked() {
    this.finalHeight = this.finalHeight + 500;
    window.scrollTo(0, this.finalHeight);
  }
  sendMessage(msg: string) {
    if (
      !(
        this.formValue ===
          "Select one of the options above or type your own question." ||
        msg === ""
      )
    ) {
      this.chat.converse(msg);
      this.formValue = "";
      //
    }
    this.initialList = false;
  }
  sendMessagefromSpeech(msg: string) {
    const result = this.chat.converse(msg);
    if (result === 0) {
      this.detectChanges();
    }
  }
  sendMessagefromButton(buttonValue: string) {
    const result = this.chat.converse(buttonValue);
    if (result === 0) {
      this.detectChanges();
    }
  }
  resetValue() {
    if (
      this.formValue ===
      "Select one of the options above or type your own question."
    ) {
      this.formValue = "";
    }
  }
  sendLink(link: string) {
    if (link === "none") {
    } else {
      window.open(link);
    }
  }
  parseBody(body: string) {
    if (body === "reset") {
      this.HomeAction();
      return "";
    }
    const matches = body.match(/\bhttps?:\/\/\S+/gi);
    if (!matches) {
      return body;
    } else {
      matches.forEach((match) => {
        const replace = '<a href="' + match + '" target="_blank">link</a>';
        body = body.replace(match, replace);
      });
      return body;
    }
  }

  // speech part
  setSpeak() {
    this.speakEnabled = !this.speakEnabled;
  }

  // (click)="speakBody(parseBody(message.content))"
  //speakBody(body: string) {
  //  if (this.speakEnabled) {
  //    speechSynthesis.cancel();
  //    let utterance = new SpeechSynthesisUtterance(body);
  //    utterance.pitch = 1.0;
  //    utterance.volume = 1;
  //    utterance.rate = 0.8;
  //    utterance.lang = "en-EN";
  //    speechSynthesis.speak(utterance);
  //  }
  //}

  startButton(event) {
    if (this.recognizing) {
      this.speechRecognizer.stop();
      this.notification = "";
      return;
    }
    this.speechRecognizer.start(event.timeStamp);
  }

  onSelectLanguage(language: string) {
    this.currentLanguage = language;
    this.speechRecognizer.setLanguage(this.currentLanguage);
  }

  private initRecognition() {
    this.speechRecognizer.onStart().subscribe((data) => {
      this.recognizing = true;
      this.formValue = "I am listening ...";
      this.detectChanges();
    });

    this.speechRecognizer.onEnd().subscribe((data) => {
      this.recognizing = false;
      this.detectChanges();
      this.notification = null;
    });

    this.speechRecognizer.onResult().subscribe((data: SpeechNotification) => {
      const message = data.content.trim();
      this.formValue = message;
      this.detectChanges();
      if (data.info === "final_transcript" && message.length > 0) {
        this.actionContext.processMessage(message, this.currentLanguage);
        this.speechRecognizer.stop();
        this.recognizing = false;
        this.sendMessagefromSpeech(message);
        this.detectChanges();
        // this.actionContext.runAction(message, this.currentLanguage);
      }
    });

    this.speechRecognizer.onError().subscribe((data) => {
      switch (data.error) {
        case SpeechError.BLOCKED:
        case SpeechError.NOT_ALLOWED:
          this.notification = `Cannot run.
            Your browser is not authorized to access your microphone. Verify that your browser has access to your microphone and try again.
            `;
          break;
        case SpeechError.NO_SPEECH:
          this.notification = `No speech has been detected. Please try again.`;
          break;
        case SpeechError.NO_MICROPHONE:
          this.notification = `Microphone is not available. Plese verify the connection of your microphone and try again.`;
          break;
        default:
          this.notification = null;
          break;
      }
      this.recognizing = false;
      this.detectChanges();
    });
  }

  detectChanges() {
    this.changeDetector.detectChanges();
  }

  HomeAction() {
    window.location.reload();
  }
  FAQAction() {
    window.open(
      "https://www.jacaranda.ro/conversational_computing/Alex",
      "_blank" // <- This is what makes it open in a new window.
    );
  }
  ShareAction() {
    this.sharePressed = true;
  }
  sendMail() {
    alert("An email hsd been sended to: " + this.emailShareValue);
    const db = app.database();
    const ref = db.ref("Emails");
    ref.push({
      email: this.emailShareValue,
      status: "new",
    });
    this.sharePressed = false;
    this.emailShareValue = "";
  }

  closeShare() {
    this.sharePressed = false;
  }
}
